export default "__VITE_ASSET__DcY9LrdL__"